/**
 * @desc 保存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.WarehouseRulesRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
